import { render, staticRenderFns } from "./InputAddressLookup.vue?vue&type=template&id=37b53e2c"
import script from "./InputAddressLookup.vue?vue&type=script&lang=js"
export * from "./InputAddressLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/input/Input.vue').default,Address: require('/home/runner/work/platform/platform/packages/client/src/components/elements/geo/address/Address.vue').default,Link: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/link/Link.vue').default,Notification: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/notification/Notification.vue').default,InputSearch: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/input/templates/search/InputSearch.vue').default,LoaderOverlay: require('/home/runner/work/platform/platform/packages/client/src/components/utils/loader/LoaderOverlay/LoaderOverlay.vue').default,Popover: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/popover/Popover.vue').default,Field: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/field/Field.vue').default,Select: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/select/Select.vue').default})
